import moment from "moment-timezone";

import { DepreciableCategory } from "../../types";

export const DEPRECIABLE_CATEGORY_CODES = Object.values(
  DepreciableCategory
) as string[];
export const LATEST_POSSIBLE_PURCHASE_DATE = moment().format("YYYY-MM-DD");
export const CUSTOM_ASSET_CLASS = "Sonstige";
